export const fetchStatus = {
    Loading: "Loading",
    OpenSuccess: "OpenSuccess",
    NotOpenSuccess: "NotOpenSuccess",
    Fail: "Fail"
};

export const selectDonationType = {
    Pledge: "pledge",
    Oneoff: "oneoff"
};

export const selectTab = {
    Stroy : "story",
    Info : "info"
};




// WEBPACK FOOTER //
// ./src/type/config-status.js